export default __webpack_public_path__ + "static/media/2.1e077f2f.jpg";